const productData = {
  tomato: {
    name: 'Tomato',
    varieties: [
      { id: 1, name: 'DAS Hybrid Tomato 101', description: 'High yielding, firm fruits, suitable for long distance transport' },
      { id: 2, name: 'DAS Hybrid Tomato 102', description: 'Early maturing, deep red color, disease resistant' },
      { id: 3, name: 'DAS Hybrid Tomato 103', description: 'Indeterminate type, suitable for all seasons' },
    ],
  },
  chilli: {
    name: 'Chilli',
    varieties: [
      { id: 1, name: 'DAS Hybrid Chilli 201', description: 'High pungency, long fruits, good shelf life' },
      { id: 2, name: 'DAS Hybrid Chilli 202', description: 'Suitable for dry red chilli production' },
    ],
  },
  brinjal: {
    name: 'Brinjal',
    varieties: [
      { id: 1, name: 'DAS Hybrid Brinjal 301', description: 'Long purple fruits, high yield potential' },
      { id: 2, name: 'DAS Hybrid Brinjal 302', description: 'Round type, glossy dark purple, early bearing' },
    ],
  },
  cucumber: {
    name: 'Cucumber',
    varieties: [
      { id: 1, name: 'DAS Hybrid Cucumber 401', description: 'Parthenocarpic, suitable for polyhouse cultivation' },
      { id: 2, name: 'DAS Hybrid Cucumber 402', description: 'Long green fruits, disease tolerant' },
    ],
  },
  capsicum: {
    name: 'Capsicum',
    varieties: [
      { id: 1, name: 'Dynasty Agriseeds DS-Ambika', description: 'Blocky open field sweet pepper, medium green to red colour, 180-250 gm fruits, ideal for fresh market with long transportability' },
      { id: 2, name: 'Ambica', description: 'Long blocky fruits, dark green to red colour, 140-150 gm average fruit weight, suitable for long distance shipping' },
    ],
  },
  bittergourd: {
    name: 'Bitter Gourd',
    varieties: [
      { id: 1, name: 'DAS Hybrid Bitter Gourd 601', description: 'Long white fruits, early maturity' },
      { id: 2, name: 'DAS Hybrid Bitter Gourd 602', description: 'Green type, high bitter content' },
    ],
  },
  watermelon: {
    name: 'Watermelon',
    varieties: [
      { id: 1, name: 'DAS Hybrid Watermelon 701', description: 'Seedless type, crispy flesh, high sugar content' },
      { id: 2, name: 'DAS Hybrid Watermelon 702', description: 'Striped skin, red flesh, suitable for summer' },
    ],
  },
  ladysfinger: {
    name: "Lady's Finger",
    varieties: [
      { id: 1, name: "DAS Hybrid Lady's Finger 801", description: 'Dark green, tender pods, high yield' },
      { id: 2, name: "DAS Hybrid Lady's Finger 802", description: 'Spineless type, long fruiting period' },
    ],
  },
  muskmelon: {
    name: 'Musk Melon',
    varieties: [
      { id: 1, name: 'DAS Hybrid Musk Melon 901', description: 'Netted skin, sweet aroma, uniform fruit size' },
      { id: 2, name: 'DAS Hybrid Musk Melon 902', description: 'Early maturity, good keeping quality' },
    ],
  },
  pumpkin: {
    name: 'Pumpkin',
    varieties: [
      { id: 1, name: 'DAS Hybrid Pumpkin 1001', description: 'Bright orange flesh, high dry matter content' },
      { id: 2, name: 'DAS Hybrid Pumpkin 1002', description: 'Strong vine vigor and uniform round fruits' },
    ],
  },
  bottlegourd: {
    name: 'Bottle Gourd',
    varieties: [
      { id: 1, name: 'DAS Hybrid Bottle Gourd 1101', description: 'Tender fruits, smooth skin, extended harvest' },
      { id: 2, name: 'DAS Hybrid Bottle Gourd 1102', description: 'High setting under varied climates' },
    ],
  },
  ridgegourd: {
    name: 'Ridge Gourd',
    varieties: [
      { id: 1, name: 'DAS Hybrid Ridge Gourd 1201', description: 'Attractive ridged fruits with high market preference' },
      { id: 2, name: 'DAS Hybrid Ridge Gourd 1202', description: 'Early bearing and consistent fruiting' },
    ],
  },
};

export default productData;
